import { NgModule, LOCALE_ID, Inject } from '@angular/core'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/fr'

@NgModule()
export class DatesModule {
  constructor(@Inject(LOCALE_ID) public locale: string) {
    // Extentions dayjs
    dayjs.extend(duration)
    dayjs.extend(relativeTime)
    dayjs.extend(isBetween)
    dayjs.extend(localizedFormat)

    // Extension des localisations
    if (locale === 'fr') {
      dayjs.locale('fr')
    }
  }
}
